import { createMultiStyleConfigHelpers as l } from "@chakra-ui/react";
import { sectionAnatomy as i } from "../anatomy/index.mjs";
import { headingTheme as t } from "./heading.mjs";
const { definePartsStyle: e, defineMultiStyleConfig: n } = l(i.keys), a = e({
  section: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    w: "full",
    bg: "surface",
    color: "onSurface.highEmphasis"
  },
  header: {
    px: { base: 4, lg: 8 },
    py: { base: 4 },
    display: "flex",
    flexDirection: "column",
    gap: "2",
    w: "full"
  },
  title: {
    minH: "10",
    ...t.baseStyle,
    fontSize: { base: "2xl", xl: "2xl" },
    lineHeight: { base: "6", xl: "8" },
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
    flexShrink: 1,
    hyphens: "manual"
  },
  titleRow: {
    display: "flex",
    flexDirection: "row",
    gap: "2",
    w: "full",
    minH: "10"
  },
  icon: {
    flexShrink: 0,
    minH: "10",
    boxSize: "icon.md"
  },
  button: {
    minH: "10"
  },
  iconButton: {
    minH: "10"
  },
  description: {
    textStyle: "bodySm",
    color: "onSurface.mediumEmphasis"
  },
  body: {
    w: "full",
    px: { base: 4, lg: 8 },
    py: { base: 6 },
    maxWidth: "unset",
    display: "flex",
    flexDirection: "column"
  },
  box: {
    px: { base: 4, lg: 8 }
  },
  footer: {
    display: "flex",
    flexDirection: "column",
    px: { base: 4, lg: 8 },
    py: { base: 6 }
  }
}), o = {
  full: e({}),
  lg: e({
    header: {
      alignSelf: "center",
      width: "full",
      maxWidth: "container.lg"
    },
    body: {
      alignSelf: "center",
      width: "full",
      maxWidth: "container.lg"
    },
    box: {
      alignSelf: "center",
      width: "full",
      maxWidth: "container.lg"
    },
    footer: {
      alignSelf: "center",
      width: "full",
      maxWidth: "container.lg"
    }
  }),
  md: e({
    header: {
      alignSelf: "center",
      width: "full",
      maxWidth: "container.md"
    },
    body: {
      alignSelf: "center",
      width: "full",
      maxWidth: "container.md"
    },
    box: {
      alignSelf: "center",
      width: "full",
      maxWidth: "container.md"
    },
    footer: {
      alignSelf: "center",
      width: "full",
      maxWidth: "container.md"
    }
  }),
  sm: e({
    header: {
      alignSelf: "center",
      width: "full",
      maxWidth: "container.sm"
    },
    body: {
      alignSelf: "center",
      width: "full",
      maxWidth: "container.sm"
    },
    box: {
      alignSelf: "center",
      width: "full",
      maxWidth: "container.sm"
    },
    footer: {
      alignSelf: "center",
      width: "full",
      maxWidth: "container.sm"
    }
  })
}, d = n({
  baseStyle: a,
  sizes: o,
  defaultProps: {}
});
export {
  d as sectionTheme
};
